import { Tag } from 'antd';
import dayjs from 'dayjs';
import { Link } from 'react-router-dom';
import BaseCellText from 'common/components/table/base-cell-text';
import { ICellRendererProps } from 'common/components/table/table.types';
import { DATE_SHORT_MMM_DD_YYYY } from 'common/constans/date.constants';
import { RentalApplicationTypeEnum, rentalApplicationTypeMap } from 'common/enums/rental-application-type.enum';
import { rentalPropertyStatusColorMap } from 'common/enums/rental-property-status.enum';
import { formatAddressLabel } from 'common/helpers/address.helper';
import styles from '../../rental-portal.module.scss';
import { IRentalApplicationRow } from './rental-properties.model';

export const rentalPropertiesInitialColumns = [
  {
    key: 'id',
    title: 'Application #',
    dataKey: 'id',
    width: 140,
    minWidth: 130,
    resizable: true,
    sortable: true,
    flexGrow: 1,
    getValue: (row: IRentalApplicationRow) => row.applicationNumber,
    cellRenderer: (cell: ICellRendererProps<IRentalApplicationRow>) => {
      return (
        <Link className={styles.numberLink} to={cell.rowData.detailsUrl}>
          {cell.rowData.applicationNumber}
        </Link>
      );
    },
  },
  {
    key: 'type',
    title: 'Type',
    dataKey: 'type',
    width: 140,
    minWidth: 120,
    resizable: true,
    sortable: true,
    flexGrow: 1,
    getValue: (row: IRentalApplicationRow) => rentalApplicationTypeMap[row.type],
    cellRenderer: (cell: ICellRendererProps<IRentalApplicationRow>) => {
      const isAgencyChange = cell.rowData.type === RentalApplicationTypeEnum.AgencyChange;

      return (
        <Tag className={`eiq-tag ${isAgencyChange ? styles.agencyChangeTag : styles.registrationTag}`}>
          {rentalApplicationTypeMap[cell.rowData.type]}
        </Tag>
      );
    },
  },
  {
    key: 'address',
    title: 'Address',
    dataKey: 'address',
    width: 230,
    minWidth: 200,
    resizable: true,
    sortable: true,
    flexGrow: 1,
    getValue: (row: IRentalApplicationRow) => formatAddressLabel(row.address),
    cellRenderer: (cell: ICellRendererProps<IRentalApplicationRow>) => {
      return <BaseCellText>{formatAddressLabel(cell.rowData.address)}</BaseCellText>;
    },
  },
  {
    key: 'ownerName',
    title: 'Owner',
    dataKey: 'ownerName',
    width: 180,
    minWidth: 160,
    resizable: true,
    sortable: true,
    flexGrow: 1,
    cellRenderer: (cell: ICellRendererProps<IRentalApplicationRow>) => {
      return <BaseCellText>{cell.rowData.ownerName}</BaseCellText>;
    },
  },
  {
    key: 'managingAgencyName',
    title: 'Agency',
    dataKey: 'managingAgencyName',
    width: 220,
    minWidth: 190,
    resizable: true,
    sortable: true,
    flexGrow: 1,
    cellRenderer: (cell: ICellRendererProps<IRentalApplicationRow>) => {
      return <BaseCellText>{cell.rowData.managingAgencyName}</BaseCellText>;
    },
  },
  {
    key: 'createdAt',
    title: 'Submitted',
    dataKey: 'createdAt',
    width: 140,
    minWidth: 120,
    resizable: true,
    sortable: true,
    flexGrow: 1,
    cellRenderer: (cell: ICellRendererProps<IRentalApplicationRow>) => {
      return <BaseCellText>{cell.rowData.createdAt && dayjs(cell.rowData.createdAt).format(DATE_SHORT_MMM_DD_YYYY)}</BaseCellText>;
    },
  },
  {
    key: 'status',
    title: 'Status',
    dataKey: 'status',
    width: 150,
    minWidth: 90,
    resizable: true,
    sortable: true,
    flexGrow: 1,
    cellRenderer: (cell: ICellRendererProps<IRentalApplicationRow>) => {
      return (
        cell?.rowData?.status && (
          <Tag className="eiq-tag" color={rentalPropertyStatusColorMap[cell.rowData.status]}>
            {cell.rowData.status}
          </Tag>
        )
      );
    },
  },
];
